import React from "react";
import { connect } from "react-redux";
import Input from "Components/input/Input";
import TextArea from "Components/textArea/TextArea";
import Button from "Components/button/Button";
import { support } from "Icons/index";
import TranslatedString from "Components/TranslatedString";
import { t } from "i18next";
import withFormState from "Components/withFormState";
import QboxmailApi from "../../qboxmailApi";

import { alertSuccess } from "Utils/alerts";
import { Icon, check } from "Icons/index";

import cx from "classnames";
import s from "./new.scss";

const links = {
  it: {
    addDomain: "https://www.qboxmail.it/documentation/aggiunta-domini-domini-alias/",
    ownership: "https://www.qboxmail.it/documentation/verifica-proprieta-dominio/",
    services: "https://www.qboxmail.it/documentation/accesso-servizi-smtp-pop3-imap/",
    mx: "https://www.qboxmail.it/documentation/impostazioni-dns/",
    mtm: "https://www.qboxmail.it/documentation/mail-time-machine/",
    limits: "https://www.qboxmail.it/documentation/numero-massimo-di-connessioni-imap/",
    smtp: "https://www.qboxmail.it/documentation/policy-servizio-smtp-autenticato/",
    policy: "https://www.qboxmail.it/documentation/policy-servizio-antispam-ed-antivirus/",
    spf: "https://www.qboxmail.it/documentation/configurazione-record-spf/",
    dkim: "https://www.qboxmail.it/documentation/configurazione-firma-dkim/",
    other: "https://www.qboxmail.it/documentazione/",
  },
  en: {
    addDomain: "https://www.qboxmail.com/documentation/add-domains-alias-domains/",
    ownership: "https://www.qboxmail.com/documentation/ownership-check-procedure/",
    services: "https://www.qboxmail.com/documentation/imap-pop-and-smtp-parameters/",
    mx: "https://www.qboxmail.com/documentation/dns-settings/",
    mtm: "https://www.qboxmail.com/documentation/mail-time-machine/",
    limits: "https://www.qboxmail.com/documentation/maximum-number-pop-imap-sessions/",
    smtp: "https://www.qboxmail.com/documentation/policy-authenticated-smtp-service/",
    policy: "https://www.qboxmail.com/documentation/policy-antispam-ed-antivirus-service/",
    spf: "https://www.qboxmail.com/documentation/setup-spf-record/",
    dkim: "https://www.qboxmail.com/documentation/setup-dkim-signature/",
    other: "https://www.qboxmail.com/docs/",
  },
};

class SupportNew extends React.Component {
  constructor(props) {
    super(props);
    this.resetSent = this.resetSent.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.state = {
      ticketSent: false,
    };
  }

  goTo(url) {
    window.open(url);
  }

  resetSent() {
    this.setState({ ticketSent: false });
  }

  submitForm(e) {
    e.preventDefault();
    const { formData, setFormLoading, unsetFormLoading, resetForm } = this.props;

    setFormLoading();

    const api = new QboxmailApi({ useCookie: true });
    api.createTicket(formData).then(() => {
      alertSuccess(t("alert.ticket.sent"));
      this.setState({ ticketSent: true });
      unsetFormLoading();
      resetForm();
    });
  }

  render() {
    const { formData, setFormFieldValue, formErrors, isFormLoading, language } = this.props;

    return (
      <div className={cx("orderPage", s.support)}>
        <div className={cx("sectionTitle", "titleFP")}>{t("support.ticket.title")}</div>
        <div className="wrapScrollFP">
          <div className="infoFP">
            <div className="sectionDesc">{t("support.ticket.desc")}</div>
          </div>

          <div className="wrapFormsFP">
            {this.state.ticketSent && (
              <div className="formsFP">
                <div className={cx("inputFull2", s.importBox)}>
                  <Icon className={s.iconImport} svg={check} width="3rem" height="3rem" />
                  <div className={s.textImport}>
                    <TranslatedString>support.ticket.sent</TranslatedString>
                  </div>
                </div>

                <div className={cx("inputFull2", s.wrapBtn)}>
                  <Button onClick={this.resetSent}>button.new.ticket</Button>
                </div>
              </div>
            )}

            {!this.state.ticketSent && (
              <form className="formsFP" method="post" onSubmit={this.submitForm}>
                <Input
                  className="inputFull2"
                  label={t("input.label.message.subject")}
                  placeholder={t("input.placeholder.message.subject")}
                  type="text"
                  name="subject"
                  onChange={setFormFieldValue}
                  value={formData.subject}
                  errors={formErrors.subject}
                  required
                />

                <TextArea
                  className="inputFull2"
                  name="body"
                  label={t("input.label.message.body")}
                  hint={t("input.hint.ticket.object")}
                  value={formData.body}
                  onChange={setFormFieldValue}
                  errors={formErrors.body}
                  required
                />
                <div className={cx("inputFull2", s.wrapBtn)}>
                  <Button loading={isFormLoading} type="submit">
                    button.send.ticket
                  </Button>
                </div>
              </form>
            )}
          </div>
        </div>
      </div>
    );
  }
}

const mapState = (state) => ({
  language: state.ui.language,
});

export default connect(mapState)(withFormState(SupportNew, { subject: "", body: "" }));
